export default {
    // API 基础路径
    // 正常构建：用线上 API
    // 预渲染构建（PRERENDER=1）：可用 VUE_APP_API_BASE_URL 环境变量覆盖
    baseURL: process.env.VUE_APP_API_BASE_URL || 'https://pointcloudyzw.com/ruoyi-admin',
    timeout: 600000, // 请求超时时间（10分钟）
    tokenKey: 'token', // token key
    wxPayAppId: 'wxb5bf904832058880', // 服务号(支付)AppID
    wxPayBindRedirectPath: '/bind-pay-wechat', // 微信支付openid绑定回调路径
    wxPayRedirectDomain: 'https://pointcloudyzw.com' // 微信网页授权域名
}
